import { lazy } from '@/service/lazy'

export default [{
  name: 'Consultas Parceiro',
  path: 'consultasparceiros',
  id: 'consultasparceiros',
  icon: 'fa fa-user',
  component: lazy('app/default/relatorios/consultasparceiros/index'),
  meta: { requireAuth: true, rules: ['relatorio_consulta_parceiros'] },
  children: []
}]



// WEBPACK FOOTER //
// ./src/router/modules/default/consultasparceiro.js